const colors = [
  { hex: '#fdfefe', rgb: 'rgb(253, 254, 254)' },
  { hex: '#c2c2c2', rgb: 'rgb(194, 194, 194)' },
  { hex: '#858585', rgb: 'rgb(133, 133, 133)' },
  { hex: '#474647', rgb: 'rgb(71, 70, 71)' },
  { hex: '#000000', rgb: 'rgb(0, 0, 0)' },
  { hex: '#3aaefe', rgb: 'rgb(58, 174, 254)' },
  { hex: '#70aaeb', rgb: 'rgb(112, 170, 235)' },
  { hex: '#4a75a8', rgb: 'rgb(74, 117, 168)' },
  { hex: '#074bf3', rgb: 'rgb(7, 75, 243)' },
  { hex: '#5e30eb', rgb: 'rgb(94, 48, 235)' },
  { hex: '#ff6d5c', rgb: 'rgb(255, 109, 92)' },
  { hex: '#fe2500', rgb: 'rgb(254, 37, 0)' },
  { hex: '#ff218b', rgb: 'rgb(255, 33, 139)' },
  { hex: '#992553', rgb: 'rgb(153, 37, 83)' },
  { hex: '#4d2c9c', rgb: 'rgb(77, 44, 156)' },
  { hex: '#ffcf4a', rgb: 'rgb(255, 207, 74)' },
  { hex: '#feb43f', rgb: 'rgb(254, 180, 63)' },
  { hex: '#fe8648', rgb: 'rgb(254, 134, 72)' },
  { hex: '#fe5a37', rgb: ': rgb(254, 90, 55)' },
  { hex: '#db5101', rgb: 'rgb(219, 81, 1)' },
  { hex: '#94df44', rgb: 'rgb(148, 223, 68)' },
  { hex: '#5cbf0d', rgb: 'rgb(92, 191, 13)' },
  { hex: '#c2cf19', rgb: 'rgb(194, 207, 25)' },
  { hex: '#cf1919', rgb: 'rgb(207, 25, 25))' },
];

export default colors;
